import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { LoginUserInfoModel } from '../kymw1000/vo/login-user-info.model';
import { KYMW1000Model } from './kymw1000.model';
import { ExecuteLoginService } from './api-services/execute-login.service';
import { OldLoginService } from './api-services/old-login.service';
import { PlessService } from 'src/app/shared/pless-service.model';
import { environment } from 'src/environments/environment';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

/**
 * ログイン画面
 * TODO 移行がすべて完了したらこのコードを削除する
 *
 * @export KYMW1000Component
 * @class KYMW1000Component
 */
@Component({
  selector: 'app-kymw1000',
  templateUrl: 'kymw1000.component.html',
  styleUrls: ['kymw1000.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1000Component extends PlessViewHelperSub implements OnInit {

  // 画面部品参照
  @ViewChild('tbx_user', { static: true }) public tbx_user: ElementRef = null;

  public kymw1000Model: KYMW1000Model = new KYMW1000Model();
  public Fingerprint: string = <string>'';

  /**
   * Creates an instance of KYMW1000Component.
   * @param {ExecuteLoginService} executeLoginService
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {OldLoginService} oldLoginService
   * @param {Router} router
   * @memberof KYMW1000Component
   */
  constructor(
    public executeLoginService: ExecuteLoginService,
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    private oldLoginService: OldLoginService,
    private router: Router,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1000Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1000';
    this.kymw1000Model.kYMW1000Component = this;

    // フィンガープリント取得
    const fpPromise = FingerprintJS.load();
    fpPromise.then(fp => fp.get()).then(result => {
      this.Fingerprint = result.visitorId;
    });
  }

  /**
   * ログインボタン押した時のイベント
   *
   * @memberof KYMW1000Component
   */
  public eventloginHandler(event): void {
    const vo = {
      userID: '',
      passWord: '',
      fingerprint: '',
    };

    // ユーザーＩＤの条件
    if (!PlessViewUtilsSub.isEmpty(this.kymw1000Model.user)) {
      if (!PlessViewUtilsSub.isEmpty(this.kymw1000Model.pass)) {
        vo.userID = this.kymw1000Model.user;
        vo.passWord = this.kymw1000Model.pass;
        vo.fingerprint = this.Fingerprint;
      } else {
        this.dialogService.openAlertGetMessage('E0110', ['パスワード']);
        return;
      }
    } else {
      this.dialogService.openAlertGetMessage('E0110', ['ユーザーＩＤ']);
      return;
    }

    this.executeLoginService.execute(vo, (data: any) => {
      this.afterLogin(data);
    });
  }

  /**
   * ログインに成功した時
   * ログイン画面を閉じてダッシュボード画面に移動する。
   */
  public eventLoginSuccess(): void {
    this.onClickClose();
  }

  // 首藤コードで使われているログイン処処理
  afterLogin(data: LoginUserInfoModel) {
    if (environment.loginToCurrentBackend) {
      // mock + 現行バックエンド 併用ログイン
      this.oldLoginService.execute({
        userID: this.kymw1000Model.user,
        passWord: this.kymw1000Model.pass
      });
    } else {
      this.kymw00Model.kymw1001Model.loginUserInfo.UserID = this.kymw1000Model.user;
      if (data.RedirectPath == null || data.RedirectPath == '') {
        this.router.navigate(['/kymw/1002']);
      } else {
        this.router.navigate([data.RedirectPath], {});
      }
    }
  }

  /**
   * パスワード再設定画面に遷移
   */
  public eventPasswordResetHandler(): void {
    this.router.navigate(['/kymw/9007'], {});
  }

  /**
   * SP-initiatedによるコープデリ職員の認証
   */
  public eventCallSamlAuthorizeHandler(): void {
    const serviceInfo = PlessService.SERVICE['callSamlAuthorize'];
    window.location.href = serviceInfo.url;
  }

}
